import AuthApi, {
	type RequestPasswordResetParams,
	type ResetPasswordParams,
} from '@/helpers/api/AuthApi'
import type { User } from '@/models/User/Model'
import { defineStore } from 'pinia'
const auth = new AuthApi()
const useAuthStore = defineStore('auth', {
	state: () => {
		return {
			user: null as User | null,
			userReturned: false,
			// Loading the signed-in user failed for another reason than not being signed in, such
			// as no connection. The app shows it instead of waiting forever.
			userError: false,
			userRequest: null as Promise<any> | null,
		}
	},
	actions: {
		async login({
			email,
			password,
			remember = false,
		}: {
			email: string
			password: string
			remember?: boolean
		}) {
			await auth.login({ email, password, remember })
			await this.getUser()
		},
		async logout() {
			await auth.logout()
			this.user = null
		},
		async getUser() {
			try {
				if (!this.userRequest) {
					this.userRequest = auth.getUser()
				}
				this.user = (await this.userRequest).data
				this.userError = false
			} catch (error: any) {
				if (error.response?.status !== 401) {
					this.userError = true
					throw error
				}
				// Not signed in (any more).
				this.user = null
				this.userError = false
			} finally {
				this.userRequest = null
			}
			this.userReturned = true
		},
		async requestPasswordReset(params: RequestPasswordResetParams) {
			return await auth.requestPasswordReset(params)
		},
		async resetPassword(params: ResetPasswordParams) {
			return await auth.resetPassword(params)
		},
	},
})

export { useAuthStore }
